interface IProps {
  className?: any;
  content?: string;
}

const PrintHtml: React.FC<IProps> = ({ className, content }) => (
  <div
    className={className}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: content || '' }}
  />
);

export default PrintHtml;
